module.exports = __webpack_public_path__ + "static/img/hotel tilun dougpu spa.2f9dc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/hotel tilun dougpu spa.png?20181011
// module id = KJMU
// module chunks = 1